module.exports = __webpack_public_path__ + "static/img/connect_img.09bd3643.png";